module.exports = __webpack_public_path__ + "static/media/Cooked_wolf_meat.0a9e5506.png";